module.exports = __webpack_public_path__ + "static/img/D4106.c5d5e033.png";